/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
import React, { useState } from "react";
import styles from "./styles.css";
import FinanceFirstCheckoutPriceBreakupModal from "../finance-first-checkout-price-breakup-modal";
// import { fastlyUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";
import PropTypes from "prop-types";
import { LOAN_PROVIDER } from "../../../constants/app-constants";
import PostBcMyBookingCarCard from "../../shared/post-bc-my-booking-car-card";
import { fastlyUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";
import { TRACKING_EVENTS } from "../order-summary-tasks/tracking";
import { trackMobileCustomEventsAU } from "../../../tracking";

const PostBcBookingCardContainer = ({
    paymentSummaryData,
    frequency = "week",
    showNumberAnimation = false,
    financeProvider,
    orderId,
    content,
    config
}) => {
    const [showPriceModal, setShowPriceModal] = useState(false);
    const [showDriveAwayPriceModal, setShowDriveAwayPriceModal] = useState(false);
    const { mainImage = "" } = content || {};
    const isFinanceUser = financeProvider === LOAN_PROVIDER.CARS24;
    const emi = paymentSummaryData?.repayment?.emi;
    const { amountDue, totalAmountToCollect, totalLoanAmount = 0 } = paymentSummaryData || {};

    const carAmountLabel = isFinanceUser
        ? "Loan amount"
        : amountDue === 0
            ? "Drive away price"
            : "Amount due";

    const totalAmount = isFinanceUser
        ? totalLoanAmount
        : amountDue === 0
            ? totalAmountToCollect
            : amountDue;

    const handleOpenPriceBreakDownModal = () => {
        if (amountDue === 0 && !isFinanceUser) {
            setShowDriveAwayPriceModal(true);
        } else {
            setShowPriceModal(true);
        }
        trackMobileCustomEventsAU(TRACKING_EVENTS.ICON_HYPERLINK_CLICKED, {
            ...TRACKING_EVENTS.ICON_HYPERLINK_CLICKED,
            eventAction: `${carAmountLabel.toLowerCase().replace(" ", "_")}_icon_hyperlink_clicked`,
            eventLabel: orderId
        });
    };

    const closeBreakupModal = () => {
        setShowPriceModal(false);
        setShowDriveAwayPriceModal(false);
    };

    const hasMainImage = mainImage && mainImage.path && config && config.imageHost ? true : false;
    const carImageUrl = hasMainImage
        ? fastlyUrl(config.imageHost, mainImage.path, imageTypes.auCarCheckoutThumbnail)
        : null;

    return (
        <div styleName={"styles.outer"}>
            <PostBcMyBookingCarCard
                handleOpenPriceBreakDownModal={handleOpenPriceBreakDownModal}
                carAmountLabel={carAmountLabel}
                totalLoanAmount={totalAmount}
                emi={emi}
                showNumberAnimation={showNumberAnimation}
                frequency={frequency}
                orderId={orderId}
                carImageUrl={carImageUrl}
                isFinanceUser={isFinanceUser}
            />
            <FinanceFirstCheckoutPriceBreakupModal isOpen={showPriceModal || showDriveAwayPriceModal} onClose={closeBreakupModal} showContactTeamCard={true}/>
        </div>
    );
};

PostBcBookingCardContainer.propTypes = {
    paymentSummaryData: PropTypes.object,
    content: PropTypes.object,
    config: PropTypes.object,
    frequency: PropTypes.string,
    financeProvider: PropTypes.string,
    showNumberAnimation: PropTypes.bool,
    splitPaymentOpted: PropTypes.bool,
    orderId: PropTypes.string
};

export default PostBcBookingCardContainer;
